import {
  FilterParams,
  SelectableItem,
} from '@features/campaign-list/domain/filter';

export type ReducerAction =
  | {
      type: 'search_text_changed';
      payload: FilterParams['searchText'];
    }
  | {
      type: 'selected_campaign_type_changed';
      payload: FilterParams['selectedCampaignType'];
    }
  | {
      type: 'selected_report_type_changed';
      payload: FilterParams['selectedReportType'];
    }
  | {
      type: 'client_selected';
      payload: FilterParams['selectedClient'];
    }
  | {
      type: 'advertiser_toggled';
      payload: SelectableItem;
    };

export const reducer = (
  state: FilterParams,
  action: ReducerAction
): FilterParams => {
  switch (action.type) {
    case 'search_text_changed': {
      return { ...state, searchText: action.payload };
    }
    case 'selected_campaign_type_changed': {
      return { ...state, selectedCampaignType: action.payload };
    }
    case 'selected_report_type_changed': {
      return { ...state, selectedReportType: action.payload };
    }
    case 'client_selected': {
      return {
        ...state,
        selectedClient: action.payload,
        checkedAdvertisers: [],
      };
    }
    case 'advertiser_toggled': {
      return {
        ...state,
        checkedAdvertisers: toggleValueInArray(
          action.payload,
          state.checkedAdvertisers
        ),
      };
    }
    default: {
      return state;
    }
  }
};

const toggleValueInArray = (value: SelectableItem, array: SelectableItem[]) => {
  return array.includes(value)
    ? array.filter(item => item.id !== value.id)
    : [...array, value];
};
